import { defineComponent as _defineComponent } from 'vue'
import { Form, message } from 'ant-design-vue';
import { getCurrentInstance, onMounted, ref, watch } from 'vue';
import { PaginationData } from '@/api/operation/customer';
import {
  getOrderList,
  getWarehouseList,
  initOrderData,
  initWarehouseData,
  OrderData,
  // exportData,
  sendOut,
} from '@/api/order/order-management';
import { request as axios } from '@/util/request';
import lodash from 'lodash';

import moment from 'moment';
import { exportOrderList } from '@/api/order/order-list';
import Redact from '@/view/ware/redact.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  setup(__props) {

const STATUS_LIST: any = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '待支付',
  },
  {
    value: 15,
    label: '待成团',
  },
  {
    value: 2,
    label: '待发货',
  },
  {
    value: 3,
    label: '待收货',
  },
  {
    value: 4,
    label: '已收货',
  },
  {
    value: 5,
    label: '已取消',
  },
  {
    value: 6,
    label: '已关闭',
  },
];
const SELECT_LIST: any = [
  {
    value: 1,
    label: '订单编号',
  },
  {
    value: 2,
    label: '收货人姓名',
  },
  {
    value: 3,
    label: '收货人手机号',
  },
  {
    value: 4,
    label: '收货人地址',
  },
  {
    value: 5,
    label: '客户ID',
  },
];
const PAY_TYPE_LIST: any = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '待接单',
  },
  {
    value: 2,
    label: '待抢单',
  },
  {
    value: 3,
    label: '超时未抢单',
  },
  {
    value: 4,
    label: '待取货',
  },
  {
    value: 5,
    label: '待送达',
  },
  {
    value: 6,
    label: '已送达',
  },
  {
    value: 7,
    label: '超时送达',
  },
];
function dateFormat(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}
const orderType = ref<'normal' | 'points'>('normal');

const columns = ref();

const result = ref([
  {
    name: '配送状态',
    body: '不通过',
  },
  {
    name: '预计送达时间',
    body: 10,
  },
  {
    name: '取货码',
    body: '客诉扣款吧啦啦啦',
  },
  {
    name: '骑手姓名',
    body: 'fgajkfdjak',
  },
  {
    name: '联系电话',
    body: '2022-02',
  },
  {
    name: '佣金（元）',
    body: '2022-02',
  },
  {
    name: '抢单时间',
    body: '2022-02',
  },
  {
    name: '取货时间',
    body: '2022-02',
  },
  {
    name: '送达时间',
    body: '2022-02',
  },
]);
async function knightInfo(record: any) {
  knight_info.value = true;
  const res = await axios.get(`/boss/knight/order/${record.knight_order.id}`);
  result.value[0].body = res.data.status == 6 ? '已送达' : '超时送达';
  result.value[1].body = moment(res.data.delivery_time * 1000).format('YYYY-MM-DD');
  result.value[2].body = res.data.pickup_code;
  result.value[3].body = res.data.knight_name;
  result.value[4].body = res.data.knight_mobile;
  result.value[5].body = res.data.knight_commission / 100;
  result.value[6].body = moment(res.data.grab_time * 1000).format('YYYY-MM-DD');
  result.value[7].body = moment(res.data.pickup_time * 1000).format('YYYY-MM-DD');
  result.value[8].body = moment(res.data.confirmed_time * 1000).format('YYYY-MM-DD');
}
function paginationOption(remote: PaginationData<OrderData>) {
  return {
    current: +remote.current || 0,
    total: remote.total || 0,
    pageSize: remote.limit || 0,
    showTotal: () => `共${remote.total}条，每页${remote.limit}条`,
  };
}
const warehouse_list = ref();
async function setWarehouseList() {
  const res: any = await getWarehouseList();
  warehouse_list.value = initWarehouseData();
  if (res.status !== 200) {
    message.error(res.message);
    return;
  }
  warehouse_list.value = initWarehouseData(res.data);
  const obj = {
    id: 0,
    name: '全部',
  };
  warehouse_list.value.unshift(obj as any);
}
setWarehouseList();

const knight_info = ref<boolean>();

const order_data = ref<PaginationData<any>>(initOrderData());
const form = ref();
function clearForm() {
  form.value.setFieldsValue({ ...initFormData });
  queryParams.value = { ...initFormData };
}
onMounted(() => {
  form.value = (Form as any)?.createForm(getCurrentInstance()?.proxy, {
    name: 'form',
  });
  query(queryParams);
});
const is_loading = ref<boolean>(false);
const initFormData = {
  search_type: 1,
  search_value: '',
  goods_title: '',
  warehouse_id: 0,
  order_time: [],
  pay_type: 0,
  order_status: 0,
  knight_name: '',
};
const queryParams = ref<any>(initFormData);

function handleChange(page: any) {
  queryParams.value = {
        ...queryParams.value,
        current:page.current||1,
      };
}
function submit(e: any) {
  e.preventDefault();
  form.value.validateFields((err, values) => {
    if (!err) {
      queryParams.value = {
        ...queryParams.value,
        current: 1,
        ...values,
      };
    }
  });
}
const tableloading = ref(false);
async function exportData(){
  const params = {...queryParams.value}

  const start_time = params.order_time?.[0]
    ? Math.floor(+params.order_time?.[0].format('x') / 1000)
    : '';
  const end_time = params.order_time?.[1]
    ? Math.floor(+params.order_time?.[1].format('x') / 1000)
    : '';
  const query_params = {
    number: params.search_type === 1 ? params.search_value : '',
    express_name: params.search_type === 2 ? params.search_value : '',
    express_mobile: params.search_type === 3 ? params.search_value : '',
    express_address: params.search_type === 4 ? params.search_value : '',
    user_id: params.search_type === 5 ? params.search_value : '',
    goods_id: params.goods_id,
    goods_title: params.goods_title,
    warehouse_id: params.warehouse_id === 0 ? '' : params.warehouse_id,
    order_create_start_time: start_time,
    order_create_end_time: end_time,
    pay_type: params.pay_type === 0 ? '' : params.pay_type,
    knight_order_status:params.knight_order_status,
    status: params.order_status === 0 ? '' : params.order_status,
    knight_name: params.knight_name,
    channel:2,
    current: params?.current || 1,
    is_download:1
  };
  exportOrderList(query_params)
}
async function query(params: any) {
  const start_time = params.order_time?.[0]
    ? Math.floor(+params.order_time?.[0].format('x') / 1000)
    : '';
  const end_time = params.order_time?.[1]
    ? Math.floor(+params.order_time?.[1].format('x') / 1000)
    : '';
  const query_params = {
    number: params.search_type === 1 ? params.search_value : '',
    express_name: params.search_type === 2 ? params.search_value : '',
    express_mobile: params.search_type === 3 ? params.search_value : '',
    express_address: params.search_type === 4 ? params.search_value : '',
    user_id: params.search_type === 5 ? params.search_value : '',
    goods_id: params.goods_id,
    goods_title: params.goods_title,
    warehouse_id: params.warehouse_id === 0 ? '' : params.warehouse_id,
    order_create_start_time: start_time,
    order_create_end_time: end_time,
    pay_type: params.pay_type === 0 ? '' : params.pay_type,
    knight_order_status:params.knight_order_status,
    status: params.order_status === 0 ? '' : params.order_status,
    knight_name: params.knight_name,
    is_download: 0,
    channel:2,
    current: params?.current || 1,
  };
  tableloading.value = true;
  order_data.value = { ...order_data.value,detail:[] }
  const res: any = await getOrderList(query_params);
  tableloading.value = false;

  if (res.status !== 200) {
    message.error(res.message);
    return;
  }
  const data = initOrderData(res.data);
  data.detail.forEach((item, index) => {
    data.detail[index] = {
      ...item,
      level: 0,
      children: [{ ...item, level: 1, id: '1-' + item.id }],
    };
  });
  order_data.value = { ...data };
}

watch(
  queryParams,
  () => {
    query(queryParams.value);
  },
  { deep: true }
);
watch(
  orderType,
  () => {
    if(orderType.value=='points'){
      queryParams.value = {...queryParams.value, pay_type:4}
    }else if(queryParams.value.pay_type==4){
      queryParams.value = {...queryParams.value, pay_type:0}
    }
    const mustColumns = [
      {
        title: '',
        width: 50,
      },
      {
        title: '商品信息',
        scopedSlots: { customRender: 'goods' },
        width: 300,
      },
      {
        title: '买家/收货人',
        scopedSlots: { customRender: 'buyer' },
        width: 200,
      },
      {
        title: '发货门店',
        scopedSlots: { customRender: 'warehouse' },
        align: 'center',
        width: 150,
      },
    ];
    const subjoinCloumns =
      orderType.value == 'normal'
        ? [
            {
              title: '商品总价',
              scopedSlots: { customRender: 'goods_cost' },
              align: 'center',
              width: 150,
            },
            {
              title: '优惠金额',
              scopedSlots: { customRender: 'coupon_deduction_amount' },
              align: 'center',
              width: 150,
            },
            {
              title: '实付金额',
              scopedSlots: { customRender: 'total_amount_paid' },
              align: 'center',
              width: 150,
            },
          ]
        : [
            {
              title: '积分价格',
              scopedSlots: { customRender: 'points' },
              align: 'center',
              width: 150,
            },
          ];
    columns.value = lodash.cloneDeep(
      [
        ...mustColumns,
        ...subjoinCloumns,
        {
          title: '订单备注',
          scopedSlots: { customRender: 'remark' },
          width: 200,
        },
        {
          title: '订单状态/配送状态',
          scopedSlots: { customRender: 'pay_type' },
          width: 150,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'knight_order' },
          width: 150,
          fixed: 'right',
        },
      ].map(item => {
        //设置列默认属性
        return {
          ...item,
          customHeaderCell: (column: any) => {
            return {
              style: {
                'text-align': 'center',
              },
            };
          },
        };
      })
    );
  },
  {
    immediate: true,
  }
);

return { __sfc: true,STATUS_LIST, SELECT_LIST, PAY_TYPE_LIST, dateFormat, orderType, columns, result, knightInfo, paginationOption, warehouse_list, setWarehouseList, knight_info, order_data, form, clearForm, is_loading, initFormData, queryParams, handleChange, submit, tableloading, exportData, query }
}

})